import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class AllResponseService {
  private responseSubject = new BehaviorSubject<any[]>([]);
  private singleResponseSubject = new BehaviorSubject<any | null>(null);

  emitAllResponse(response: any) {

    this.responseSubject.next(response);
  }

  emitSingleResponse(response: any) {
    this.singleResponseSubject.next(response);
  }

  getAllResponseStream(): Observable<any[]> {
    return this.responseSubject.asObservable();
  }

  getSingleResponseStream(): Observable<any | null> {
    return this.singleResponseSubject.asObservable();
  }
}
